import { buildCrudRoutes } from 'Arch/components/crud/CrudRouter';

export default [
  ...buildCrudRoutes({
    baseName: 'archivesCategory',
    basePath: 'archives-category',
    baseBreadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        to: 'dashboard',
      },
      {
        text: 'Listagem de categorias',
        disabled: false,
        to: 'archivesCategory.list',
      },
    ],
    listRoute: {
      pageContent: () => import('App/archivesCategory/ArchivesCategoryCrudList.vue'),
      pageTitle: 'Listagem de categorias',
      newRouteName: 'archivesCategory.new',
      btnText: 'Adicionar categoria',
      navigateBackRoute: 'dashboard',
    },
    newRoute: {
      component: () => import('App/archivesCategory/ArchivesCategoryForm.vue'),
      breadcrumbs: [
        {
          text: 'Adicionar categoria',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('App/archivesCategory/ArchivesCategoryForm.vue'),
      breadcrumbs: [
        {
          text: 'Editar categoria',
          disabled: true,
        },
      ],
    },
  }),
];
